export const environment = {
	production: true,
	apiUrl: 'https://api-stream.paseshow.com.ar/',
  apiUrlPermissions: 'https://services.paseshow.com.ar/permissions/',
	url: 'https://live.paseshow.com.ar',
	socketUrl: ''
};
